<template>
  <v-layout row justify-center>
    <v-dialog v-model="fIdialogShow" persistent max-width="600px">
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template>-->
      <template v-slot:activator="{ on }">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              style="right:50px; top:40px;"
              class="mt-5 mr-0"
              v-on="on"
              absolute
              dark
              small
              fab
              top
              right
              color="primary"
              @click="openForm()"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>Adicionar índice financeiro</span>
        </v-tooltip>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Cadastro de índice financeiro</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="financialIndexForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6 px-3>
                  <v-select
                    class="selectOverflowHiden"
                    :rules="$store.state.formRules.requiredSelect"
                    v-model="condominium_id"
                    :items="condominiumsList"
                    item-text="name_fantasy"
                    item-value="id"
                    @change="getBuildings"
                    label="Selecione o condomínio"
                  ></v-select>
                </v-flex>
                <v-flex xs6 px-3>
                  <v-select
                    class="selectOverflowHiden"
                    :rules="$store.state.formRules.required"
                    v-model="building_id"
                    :items="buildingsList"
                    :disabled="!condominium_id"
                    item-text="name"
                    item-value="id"
                    label="Selecione a área"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="name"
                    label="Nome do índice"
                    :rules="$store.state.formRules.required"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blueGrey darken-1" flat @click="closeForm">Cancelar</v-btn>
          <v-btn color="primary" flat @click="doSave">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'RegisterFinancialIndex',

  props: {
    editDataFinancialIndex: Object,
    fIdialogShow: Boolean,
    closeForm: Function,
    openForm: Function,
    getFinancialIndex: Function,
    condominiumsList: Array
  },

  data () {
    return {
      id: '',
      condominium_id: '',
      building_id: '',
      name: '',
      buildingsList: [],
      validForm: true
    }
  },

  watch: {
    editDataFinancialIndex (val) {
      this.id = ''
      this.condominium_id = ''
      this.name = ''
      this.building_id = ''
      this.$refs.financialIndexForm.resetValidation()
      if (val) {
        console.log(val)
        this.editFinancialIndex(val)
      } else {
        // console.log(val);
      }
    }
  },

  methods: {
    editFinancialIndex (data) {
      console.log(data)
      this.id = data.id
      this.condominium_id = data.condominium_id
      this.name = data.name
      this.getBuildings().then(_ => {
        let id = data.building_id
          ? data.building_id
          : data.building_id.toString()
        this.building_id = id
      })
    },

    doSave () {
      if (!this.$refs.financialIndexForm.validate()) {
        return
      }
      let query = {
        condominium_id: this.condominium_id,
        building_id: this.building_id,
        name: this.name
      }
      let obj = {
        url: '/api/financial' + (this.id ? `/${this.id}` : ''),
        query: query,
        method: this.id ? 'patch' : 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        let obj = {
          message: `${response.data.message}`,
          title: 'Sucesso',
          callback: _ => {
            this.getFinancialIndex()
            this.closeForm()
          },
          type: 'success',
          btConfirm: { name: 'Ok', show: true },
          btCancel: { name: 'Não', show: false }
        }
        this.$store.commit('confirmMessage/showConfirmMessage', obj)
      })
    },

    async getBuildings () {
      let obj = {
        url: '/api/financial/buildList/' + this.condominium_id,
        query: '',
        method: 'get'
      }
      await this.$store.dispatch('request/doRequest', obj).then(response => {
        this.buildingsList = response.data
        let allBuildings = {
          id: '0',
          name: 'Todas as áreas'
        }
        this.buildingsList.unshift(allBuildings)
      })
    }
  }
}
</script>
